// extracted by mini-css-extract-plugin
export default {"card_wrapper":"Card_card_wrapper__LImvL"};